import React from 'react';
import { useTranslation } from 'react-i18next';
import { LiliButton } from '@lili/lili-frontend-common';
import Heading from '../../../../generic-components/Heading';
import { ReactComponent as FormAvailableIcon } from '../../../../assets/icons/svg/stamp-icons/ic-stamp-success.svg';
import { useGenerateForm } from '../../hooks/useGenerateForm';
import { useGetFormsList } from '../../hooks/useGetFormsList';
import { GENERATE_DISCLAIMER_MAP, STYLES } from '../../consts';
import { trackMixPanel } from '../../../../services/mixpanel.service';
import { getFormNumber } from '../../utils';

const { GENERATE_AVAILABLE } = STYLES;

interface IGenerate {
    formType: string;
    formId: string,
    year: number
}
export const Generate = ({ formId, formType, year }: IGenerate) => {
  const { t } = useTranslation();
  /** Hooks */
  const { mutateAsync, isLoading } = useGenerateForm({ formType, formId, year });
  const { refetch } = useGetFormsList({ formType, disableAutoFetch: true, prevActiveYear: year });
  const handleGenerate = async () => {
    mutateAsync()
      .then(() => {
        trackMixPanel(`View form ${getFormNumber(formType)} Success Screen`);
        refetch();
      });
  };
  return (
    <div className={GENERATE_AVAILABLE.WRAPPER}>
      <FormAvailableIcon className={GENERATE_AVAILABLE.ICON} />
      <Heading title={t(GENERATE_DISCLAIMER_MAP[formType as keyof typeof GENERATE_DISCLAIMER_MAP].header)} className={GENERATE_AVAILABLE.HEADER} />
      <Heading title={t(GENERATE_DISCLAIMER_MAP[formType as keyof typeof GENERATE_DISCLAIMER_MAP].subheader)} className={GENERATE_AVAILABLE.SUBHEADER} />
      <Heading
        title={t(GENERATE_DISCLAIMER_MAP[formType as keyof typeof GENERATE_DISCLAIMER_MAP].content)}
        className={GENERATE_AVAILABLE.DISCLAIMER}
      />
      <LiliButton disabled={isLoading} isLoading={isLoading} onClick={handleGenerate} className={GENERATE_AVAILABLE.ACTION} title={t(GENERATE_DISCLAIMER_MAP[formType as keyof typeof GENERATE_DISCLAIMER_MAP].action)} id='generateForm' />
    </div>
  );
};
